import React, { Component } from 'react';
import {
  ResponsiveContainer,
  ComposedChart,
  Bar,
  XAxis,
  YAxis,
  Line,
  Tooltip,
  Legend,
} from 'recharts';
class CalcadoChart extends Component {
  _secondsToLabel = (val) => {
    if(val === 0)
      return `0 min 0 seg`;

    const [ minutes, seconds='0' ] = `${val/60}`.split('.');
    const secondsLabel = `${60 * parseInt(seconds.slice(0,2)) / 10}`.slice(0, 2);

    if (seconds === '0' || parseInt(secondsLabel) >= 60)
      return `${minutes} min`;
      

    return `${minutes} min ${secondsLabel} seg`;
  }
  render(){
    const {data, conversaoData} = this.props;
    return (<div>
      <div style={{marginTop: 0}}>
        <p style={{margin:0}} className="heading has-text-centered is-size-6">Calçados </p>
        <ResponsiveContainer width="100%" height={250}>
          <ComposedChart data={data}
          syncId="calcadoChart"
            margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
            <XAxis dataKey="row" minTickGap={1} />
            <YAxis yAxisId="left" />
            <YAxis yAxisId="right" orientation="right" tickFormatter={val => this._secondsToLabel(val)} />
            <Tooltip content={<CustomToolTip />}/>
            <Legend />
            <Bar name="Atentidos" yAxisId="left" dataKey="visitantesAtendidos" stackId="a"barSize={20} fill="#2C45B4" />
            <Bar name="Visitantes" yAxisId="left" dataKey="visitantesChart" stackId="a" barSize={20} fill="#00d1b2" />
            <Bar name="Acompanhados" yAxisId="left" dataKey="visitantesAcompanhados" barSize={20} fill="#956AE9" />
            <Line name="Tempo Médio" type="monotone" yAxisId="right" dataKey="tempoMedio" fill="#363636" stroke="#363636"strokeWidth={2}  />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
      <div style={{marginTop: 20}}>
        <p style={{margin:0}} className="heading has-text-centered is-size-6">Atendidos vs Conversão </p>
        <ResponsiveContainer width="100%" height={250}>
          <ComposedChart data={data}
            syncId="calcadoChart"
            margin={{ top: 0, right: 30, left: 0, bottom: 0 }}>
            <XAxis dataKey="row" minTickGap={1} />
            <YAxis yAxisId="left" />
            <YAxis yAxisId="right" orientation="right" tickFormatter={val => this._secondsToLabel(val)}  />
            <Tooltip content={<CustomToolTipAtendidos />}/>
            <Legend />
            <Bar name="Atendidos" yAxisId="left" dataKey="visitantesAtendidos" barSize={20} fill="#00d1b2" />
            <Bar name="Conversão" yAxisId="left" dataKey="calcadoAtendidasConver" barSize={20} fill="#2C45B4" />
            <Line name="Tempo Médio até Atendimento" type="monotone" tickFormatter={val => this._secondsToLabel(val)} yAxisId="right" dataKey="calcadoAtendidasTempo" fill="#363636" stroke="#363636" strokeWidth={2} />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
      <div style={{marginTop: 20}}>
        <p style={{margin:0}} className="heading has-text-centered is-size-6">Vendas </p>
        <ResponsiveContainer width="100%" height={250}>
          <ComposedChart data={conversaoData}
            syncId="calcadoChart"
            margin={{ top: 0, right: 30, left: 0, bottom: 0 }}>
            <XAxis dataKey="row" minTickGap={1} />
            <YAxis yAxisId="left" />
            <YAxis yAxisId="right" orientation="right" domain={['dataMin', 'dataMax + 5']}  />
            <Tooltip />
            <Legend />
            <Bar name="Visitantes" yAxisId="left" dataKey="visitantes" barSize={20} fill="#00d1b2" />
            <Bar name="Quantidade de Tickets" yAxisId="left" dataKey="qtdCupons" barSize={20} fill="#2C45B4" />
            <Line name="Conversão" label={{position: 'top', offset: 5, formatter:(val => `${val}%`)}} type="monotone" yAxisId="right" dataKey="conversionRate" fill="#363636" unit="%" stroke="#363636" strokeWidth={2} />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
      <div style={{marginTop: 20}}>
        <p style={{margin:0}} className="heading has-text-centered is-size-6">Caixas </p>
        <ResponsiveContainer width="100%" height={250}>
          <ComposedChart data={data}
            syncId="calcadoChart"
            margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
            <XAxis dataKey="row" minTickGap={1} />
            <YAxis yAxisId="left" />
            <YAxis yAxisId="right" orientation="right" />
            <Tooltip />
            <Legend />
            <Bar name="Quantidade de Caixas" yAxisId="left" dataKey="qtdCaixas" barSize={20} fill="#00d1b2" />
            <Line name="Média de Caixas por Pessoa" type="monotone" yAxisId="right" dataKey="qtdCaixasMedia" fill="#363636" stroke="#363636"strokeWidth={2}  />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </div>)
  }
}

class CustomToolTip extends Component {
  _secondsToLabel = (val) => {
    if(val === 0)
      return `0 min 0 seg`;

    const [ minutes, seconds='0' ] = `${val/60}`.split('.');
    const secondsLabel = `${60 * parseInt(seconds.slice(0,2)) / 10}`.slice(0, 2);

    if (seconds === '0' || parseInt(secondsLabel) >= 60)
      return `${minutes} min`;
      

    return `${minutes} min ${secondsLabel} seg`;
  }
  render() {
    const { active } = this.props;
    if(active) {
      const { payload=[] } = this.props;
      const data = payload[0] || { payload: {} };
      return (<div className="card" style={{ padding: 10 }}>
          <p style={{ marginBottom: 10}}>
            {data.payload.row}
          </p>
          <p style={{color: '#00d1b2', marginBottom: 10}}>
            Visitantes : {data.payload.visitantes}
          </p>
          <p style={{color: '#2C45B4', marginBottom: 10}}>
            Atentidos : {data.payload.visitantesAtendidos}
          </p>

          <p style={{color: '#956AE9', marginBottom: 10}}>
            Acompanhados : {data.payload.visitantesAcompanhados}
          </p>
          <p style={{color: '#363636', marginBottom: 5}}>
            Tempo Médio na Área : { this._secondsToLabel(data.payload.tempoMedio)}
          </p>
          
      </div>)
    }
    return null;
  }
}

class CustomToolTipAtendidos extends Component {
  _secondsToLabel = (val) => {
    if(val === 0)
      return `0 min 0 seg`;

    const [ minutes, seconds='0' ] = `${val/60}`.split('.');
    const secondsLabel = `${60 * parseInt(seconds.slice(0,2)) / 10}`.slice(0, 2);

    if (seconds === '0' || parseInt(secondsLabel) >= 60)
      return `${minutes} min`;
      

    return `${minutes} min ${secondsLabel} seg`;
  }
  render() {
    const { active } = this.props;
    if(active) {
      const { payload=[] } = this.props;
      const data = payload[0] || { payload: {} };
      return (<div className="card" style={{ padding: 10 }}>
          <p style={{ marginBottom: 10}}>
            {data.payload.row}
          </p>
          <p style={{color: '#00d1b2', marginBottom: 10}}>
            Atentidos : {data.payload.visitantesAtendidos}
          </p>
          <p style={{color: '#2C45B4', marginBottom: 10}}>
            Conversão : {data.payload.calcadoAtendidasConver}
          </p>
          <p style={{color: '#363636', marginBottom: 5}}>
            Tempo Médio Até Atendimento : { this._secondsToLabel(data.payload.calcadoAtendidasTempo)}
          </p>

          
      </div>)
    }
    return null;
  }
}

export default CalcadoChart;